module.exports = __webpack_public_path__ + "static/light_right-af4a9b633d8954c95aa49bd3ba5bc380.png";